import { defineStore } from "pinia";

export const useComponentsStore = defineStore("components", {
    state: () => ({
        showChangeProfileModal: false,
		showChangeHelpModal: false,
    }),
    actions: {
        async openChangeProfileModal() {
            this.showChangeProfileModal = true;
        },
        async clodeChangeProfileModal() {
            this.showChangeProfileModal = false;
        },
		async openChangeHelpModal() {
            this.showChangeHelpModal = true;
        },
        async clodeChangeHelpModal() {
            this.showChangeHelpModal = false;
        }
    },
});
